export { ReactComponent as TooltipRemove } from './svgs/tooltip-remove.svg';
